/*
 * Normcore image viewer (UX look/ficha, 1-11): the full-screen viewer with zoom of the product page ("Ver prenda completa"),
 * as a reusable piece so the look gallery behaves the same. Same gestures: wheel / buttons / + - keys, double click or double tap
 * (2.5x), pinch, drag when zoomed, swipe at scale 1, arrows, Esc closes and focus returns to the opener. Scale 1..4, the image never leaves the stage.
 * Markup: a <dialog> with [data-nc-viewer-stage] > [data-nc-viewer-img], [data-nc-viewer-pos] and buttons [data-nc-viewer-act="prev|next|in|out|close"].
 *   NcImageViewer.open(dialog, { srcs, index, trigger, alt(i) -> string, pos(i, n) -> string })
 *   NcImageViewer.clampZoom / clampPan are pure (exported for node:test).
 */
(function (root) {
  function clampZoom(z) { return Math.min(4, Math.max(1, Number(z) || 1)); }
  function clampPan(x, y, z, w, h) {
    var mx = (w * (z - 1)) / 2, my = (h * (z - 1)) / 2;
    return { x: Math.min(mx, Math.max(-mx, x)), y: Math.min(my, Math.max(-my, y)) };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { clampZoom: clampZoom, clampPan: clampPan };
  if (typeof document === 'undefined') return;

  var STATE = new WeakMap();

  function wire(dlg, st) {
    var stage = dlg.querySelector('[data-nc-viewer-stage]');
    var img = dlg.querySelector('[data-nc-viewer-img]');
    var pts = {}, pinch = null, pan = null, lastTap = 0;
    function centre(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 }; }
    function zoom(z, cx, cy) {
      var nz = clampZoom(z);
      var k = nz / st.z;
      var x = (cx || 0) - ((cx || 0) - st.x) * k;
      var y = (cy || 0) - ((cy || 0) - st.y) * k;
      var r = img.getBoundingClientRect();
      var w = r.width / st.z || stage.clientWidth, h = r.height / st.z || stage.clientHeight;
      var c = clampPan(nz === 1 ? 0 : x, nz === 1 ? 0 : y, nz, w, h);
      st.z = nz; st.x = c.x; st.y = c.y;
      img.style.transform = 'translate(' + c.x + 'px,' + c.y + 'px) scale(' + nz + ')';
      stage.setAttribute('data-zoomed', nz > 1 ? 'true' : 'false');
    }
    function show(i) {
      var n = st.opts.srcs.length;
      st.i = ((i % n) + n) % n;
      img.src = st.opts.srcs[st.i];
      img.alt = st.opts.alt ? st.opts.alt(st.i) : '';
      var pos = dlg.querySelector('[data-nc-viewer-pos]');
      if (pos) pos.textContent = n > 1 && st.opts.pos ? st.opts.pos(st.i, n) : '';
      zoom(1, 0, 0);
    }
    st.show = show; st.zoom = zoom;
    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      var t = st.opts && st.opts.trigger;
      st.open = false;
      if (t && t.isConnected) t.focus({ preventScroll: true });
    });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nc-viewer-act]');
      if (!b || !st.open) return;
      var act = b.getAttribute('data-nc-viewer-act');
      if (act === 'close') dlg.close();
      else if (act === 'prev') show(st.i - 1);
      else if (act === 'next') show(st.i + 1);
      else if (act === 'in') zoom(st.z * 1.5, 0, 0);
      else if (act === 'out') zoom(st.z / 1.5, 0, 0);
    });
    dlg.addEventListener('keydown', function (e) {
      if (!st.open) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(st.i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(st.i + 1); }
      else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoom(st.z * 1.5, 0, 0); }
      else if (e.key === '-') { e.preventDefault(); zoom(st.z / 1.5, 0, 0); }
    });
    stage.addEventListener('wheel', function (e) {
      if (!st.open) return;
      e.preventDefault();
      var c = centre(e);
      zoom(st.z * (e.deltaY < 0 ? 1.15 : 1 / 1.15), c.x, c.y);
    }, { passive: false });
    stage.addEventListener('dblclick', function (e) { if (!st.open) return; var c = centre(e); zoom(st.z > 1 ? 1 : 2.5, c.x, c.y); });
    stage.addEventListener('pointerdown', function (e) {
      if (!st.open) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* old browsers */ }
      var ids = Object.keys(pts);
      if (ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, z: st.z };
        pan = null;
      } else if (ids.length === 1) {
        var now = Date.now();
        if (e.pointerType === 'touch' && now - lastTap < 300) { var c = centre(e); zoom(st.z > 1 ? 1 : 2.5, c.x, c.y); lastTap = 0; } else lastTap = now;
        pan = { x: e.clientX, y: e.clientY, ox: st.x, oy: st.y };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!st.open || !pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pts);
      if (pinch && ids.length === 2) {
        var a = pts[ids[0]], b = pts[ids[1]];
        var r = stage.getBoundingClientRect();
        zoom(pinch.z * (Math.hypot(a.x - b.x, a.y - b.y) / pinch.d), (a.x + b.x) / 2 - r.left - r.width / 2, (a.y + b.y) / 2 - r.top - r.height / 2);
        return;
      }
      if (pan && st.z > 1) {
        var rr = img.getBoundingClientRect();
        var c = clampPan(pan.ox + e.clientX - pan.x, pan.oy + e.clientY - pan.y, st.z, rr.width / st.z, rr.height / st.z);
        st.x = c.x; st.y = c.y;
        img.style.transform = 'translate(' + c.x + 'px,' + c.y + 'px) scale(' + st.z + ')';
      } else if (pan) pan.dx = e.clientX - pan.x;
    });
    function end(e) {
      delete pts[e.pointerId];
      if (Object.keys(pts).length < 2) pinch = null;
      if (pan && st.open && st.z === 1 && Math.abs(pan.dx || 0) > 50) show(st.i + (pan.dx < 0 ? 1 : -1));
      if (!Object.keys(pts).length) pan = null;
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
  }

  function open(dlg, opts) {
    if (!dlg || typeof dlg.showModal !== 'function' || !opts || !opts.srcs || !opts.srcs.length) return false;
    var st = STATE.get(dlg);
    if (!st) { st = { z: 1, x: 0, y: 0, i: 0, open: false }; STATE.set(dlg, st); wire(dlg, st); }
    st.opts = opts; st.open = true;
    dlg.querySelectorAll('[data-nc-viewer-act="prev"], [data-nc-viewer-act="next"]').forEach(function (b) { b.hidden = opts.srcs.length < 2; });
    st.show(opts.index || 0);
    dlg.showModal();
    document.documentElement.style.overflow = 'hidden';
    return true;
  }

  root.NcImageViewer = { open: open, clampZoom: clampZoom, clampPan: clampPan };
})(typeof window !== 'undefined' ? window : globalThis);
